import { GlBadge } from '@gitlab/ui';
import MultipleChoiceSelector from '~/vue_shared/components/multiple_choice_selector.vue';
import MultipleChoiceSelectorItem from '~/vue_shared/components/multiple_choice_selector_item.vue';
export default {
    name: 'DuoMultiSelectOptions',
    components: {
        GlBadge,
        MultipleChoiceSelector,
        MultipleChoiceSelectorItem
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        checkedIds: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    computed: {
        optionRows () {
            const checked = new Set(this.checkedIds);
            return this.options.map((option)=>({
                    ...option,
                    isChecked: checked.has(option.id)
                }));
        }
    }
};
